export default class BtnInMobileNavBar {
    constructor(topOffset = 280) {
        const topBtn = () => function () {
            const top = window.scrollY;
            const btn = document.querySelector('.js-send-resume-mobile-full');
            if (window.innerWidth > 715) {
                btn.classList.remove('--active');
            } else {
                if (top > topOffset) {
                    btn.classList.add('--active');
                } else {
                    btn.classList.remove('--active');
                }
            }
        }

        document.addEventListener('scroll', topBtn());
    }
}
